import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceContactDelegation } from "../../Model/ServiceContactDelegation/ServiceContactDelegation";

export async function createServiceContactDelegationService(data) {
    let response = await getAPIResponse("/v1/service-contact-delegation", data, "POST");
    if (response === null) {
        return null;
    }
    return ServiceContactDelegation.createFromResponseData(response);
}